import { render } from "./lesson-item.vue?vue&type=template&id=4945a4b8&scoped=true"
import script from "./lesson-item.vue?vue&type=script&lang=js"
export * from "./lesson-item.vue?vue&type=script&lang=js"

import "./lesson-item.vue?vue&type=style&index=0&id=4945a4b8&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4945a4b8"]])

export default __exports__